import './App.css';
import React, { useState } from 'react';
import FlashcardsApp from './FlashcardsApp';
import PassiveLearningApp from './PassiveLearningApp';
import MultipleChoiceApp from './MultipleChoiceApp';
import wordList7_5 from './wordList7-5';
import wordList7_6 from './wordList7-6';
import wordList8_1 from './wordList8-1';
import wordList8_2 from './wordList8-2';
import wordList8_3 from './wordList8-3';
import wordList8_4 from './wordList8-4';

const now = new Date();
const BUILD_DATE = `${String(now.getDate()).padStart(2,'0')}.${String(now.getMonth()+1).padStart(2,'0')}.${now.getFullYear()}`;

const ALL_WORDS = [...wordList7_5, ...wordList7_6, ...wordList8_1, ...wordList8_2, ...wordList8_3, ...wordList8_4];

const CHAPTERS = {
  'all': { id: 'all', name: 'Wszystkie',    words: ALL_WORDS,    code: 'ALL' },
  '7-5': { id: '7-5', name: 'Rozdział 7·5', words: wordList7_5, code: '7·5' },
  '7-6': { id: '7-6', name: 'Rozdział 7·6', words: wordList7_6, code: '7·6' },
  '8-1': { id: '8-1', name: 'Rozdział 8·1', words: wordList8_1, code: '8·1' },
  '8-2': { id: '8-2', name: 'Rozdział 8·2', words: wordList8_2, code: '8·2' },
  '8-3': { id: '8-3', name: 'Rozdział 8·3', words: wordList8_3, code: '8·3' },
  '8-4': { id: '8-4', name: 'Rozdział 8·4', words: wordList8_4, code: '8·4' },
};

const MODES = {
  passive: { id: 'passive', name: 'Ucz się',     desc: 'Odkryj tłumaczenie jednym kliknięciem', Component: PassiveLearningApp },
  choice:  { id: 'choice',  name: 'Test wyboru', desc: 'Wybierz poprawną odpowiedź z trzech opcji', Component: MultipleChoiceApp },
  active:  { id: 'active',  name: 'Sprawdź się', desc: 'Wpisz tłumaczenie z pamięci', Component: FlashcardsApp },
};

function getSavedChapter() {
  try {
    const saved = localStorage.getItem('fiszki-chapter');
    return saved && CHAPTERS[saved] ? saved : null;
  } catch { return null; }
}

function App() {
  const [selection, setSelection] = useState({ chapter: getSavedChapter(), mode: null });

  const handleBack = () => setSelection(prev => ({ ...prev, mode: null }));

  const handleChapterSelect = (chapterId) => {
    try { localStorage.setItem('fiszki-chapter', chapterId); } catch {}
    setSelection(prev => ({ ...prev, chapter: chapterId }));
  };

  const handleModeSelect = (modeId) => {
    setSelection(prev => ({ ...prev, mode: modeId }));
  };

  const { chapter, mode } = selection;
  const selectedChapter = chapter ? CHAPTERS[chapter] : null;
  const selectedMode = mode ? MODES[mode] : null;

  const versionFooter = (
    <div style={{ position: 'fixed', bottom: '5px', right: '8px', color: 'var(--text-3)', fontSize: '9px', zIndex: 9999, pointerEvents: 'none', fontFamily: 'var(--font-display)', letterSpacing: '0.1em' }}>
      v.{BUILD_DATE}
    </div>
  );

  if (!selectedChapter || !selectedMode) {
    return (
      <div className="start-screen">
        <div className="app-header">
          <div className="app-title">FISZKI</div>
          <div className="app-subtitle">Nauka słówek · Deutsch</div>
        </div>

        <div className="mode-description">
          <div className="mode-desc-item">
            <span className="mode-desc-badge">Ucz się</span>
            <span>Odkryj tłumaczenie jednym kliknięciem</span>
          </div>
          <div className="mode-desc-item">
            <span className="mode-desc-badge">Test</span>
            <span>Wybierz poprawną odpowiedź z trzech opcji</span>
          </div>
          <div className="mode-desc-item">
            <span className="mode-desc-badge">Sprawdź</span>
            <span>Wpisz tłumaczenie z pamięci po niemiecku</span>
          </div>
        </div>

        <div className="selection-grid">
          <div className="selection-column">
            <div className="column-label">Rozdział</div>
            {Object.values(CHAPTERS).map(ch => (
              <button
                key={ch.id}
                onClick={() => handleChapterSelect(ch.id)}
                className={chapter === ch.id ? 'selected' : ''}
              >
                <span className="ch-code">{ch.code}</span>
                <span className="ch-name">{ch.name}</span>
                <div className="selection-indicator"><div className="check-mark" /></div>
              </button>
            ))}
          </div>

          <div className="selection-column modes-column">
            <div className="column-label">Tryb nauki</div>
            {Object.values(MODES).map(m => (
              <button
                key={m.id}
                onClick={() => handleModeSelect(m.id)}
                disabled={!chapter}
                className={mode === m.id ? 'selected' : ''}
              >
                <span className="ch-name">{m.name}</span>
                <div className="selection-indicator"><div className="check-mark" /></div>
              </button>
            ))}
            {!chapter && <div className="select-chapter-hint">Najpierw wybierz rozdział →</div>}
          </div>
        </div>

        {versionFooter}
      </div>
    );
  }

  const Component = selectedMode.Component;
  return (
    <>
      <Component words={selectedChapter.words} onBack={handleBack} />
      {versionFooter}
    </>
  );
}

export default App;
